import { ArrowDropDown, Close, ContentCopy } from "@mui/icons-material"
import { IconButton } from "@mui/material"
import useAnchor from "../../hooks/useAnchor"
import useToast from "../../hooks/useToast"
import useTranslate from "../../hooks/useTranslate"
import ConfirmButton from "../ConfirmButton/ConfirmButton"
import ShowMoreInfoPopover from "../ShowMoreInfoPopover/ShowMoreInfoPopover"
import styles from './ConcessionUserItem.module.scss'

interface Props {
    concessionOrganizationUser: any
    onDelete: () => void
}

export default function ConcessionUserItem({ concessionOrganizationUser, onDelete }: Props) {
    const t = useTranslate()
    const [anchor, setAnchor] = useAnchor()
    const { successToast } = useToast()


    const handleOpenPopover = (event: any) => {
        setAnchor(event?.currentTarget)
    }

    const handleClosePopover = () => {
        setAnchor(null)
    }

    const handleCopyToClipboard = () => {
        navigator.clipboard.writeText(concessionOrganizationUser?.user?.email)
        successToast("Email copiado para a área de transferência")
    }

    return (
        <p className={styles.Role}>
            {concessionOrganizationUser?.user?.name}
            <IconButton
                onClick={handleOpenPopover}
                size="small"
                sx={{ p: 0, ml: 0, verticalAlign: "middle" }}
            >
                <ArrowDropDown sx={{ fontSize: 22 }} />
            </IconButton>
            {" | "}
            {t(concessionOrganizationUser?.role, "lowercase")}

            <ConfirmButton onClick={onDelete} message="Tem a certeza que pretende remover colaborador?">
                <Close fontSize="small" />
            </ConfirmButton>

            <ShowMoreInfoPopover anchor={anchor} setAnchor={handleClosePopover}>
                <div className={styles.PopoverWrapper}>
                    <p><b>email:</b> {concessionOrganizationUser?.user?.email}
                        <IconButton
                            size="small"
                            sx={{ p: 0, ml: 1, verticalAlign: "middle" }}
                            onClick={handleCopyToClipboard}

                        >
                            <ContentCopy sx={{ fontSize: 16 }} />
                        </IconButton>
                    </p>
                    <p><b>telefone:</b> {concessionOrganizationUser?.user?.phone}</p>
                </div>
            </ShowMoreInfoPopover>
        </p>
    )
}
